import * as THREE from 'three';
import { isOverlay } from './edges';
import { isModelMesh } from './picking';

interface Swap {
  object: THREE.Object3D;
  material?: THREE.Material | THREE.Material[];
  visible: boolean;
}

/** Draws every mesh of `model` with `material` and hides its lines and overlays until `restore`. */
export function swapMaterials(model: THREE.Object3D, material: THREE.Material): () => void {
  const swaps: Swap[] = [];
  model.traverse((child) => {
    if (isModelMesh(child)) {
      swaps.push({ object: child, material: child.material, visible: child.visible });
      child.material = material;
    } else if (child !== model && (isOverlay(child) || (child as THREE.Line).isLine)) {
      swaps.push({ object: child, visible: child.visible });
      child.visible = false;
    }
  });
  return () => {
    for (const { object, material: original, visible } of swaps) {
      if (original) (object as THREE.Mesh).material = original;
      object.visible = visible;
    }
  };
}
